import { render, staticRenderFns } from "./module.vue?vue&type=template&id=036c0d58&scoped=true&"
import script from "./module.vue?vue&type=script&lang=js&"
export * from "./module.vue?vue&type=script&lang=js&"
import style0 from "./module.vue?vue&type=style&index=0&id=036c0d58&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036c0d58",
  null
  
)

export default component.exports